import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DOCUMENT} from '@angular/common';
import {ConsentService} from '@core/services/consent.service';
import {ControlsOf} from '@tisa-group/core';
import {ASSET_MAP, AssetMap} from '@core/constants/client-asset-maps';
import {LanguageService} from '@core/services/language.service';
import {BehaviorSubject} from 'rxjs';

type BannerLayerType = 'main' | 'detailed';

export interface ConsentFormValues {
  bradmax: boolean;
  googleAnalytics: boolean;
  googleMarketingPersonalization: boolean;
  googleMarketingAdStorage: boolean;
  googleMarketingAdUserData: boolean;
  expires?: number;
}

@Component({
  selector: 'app-consent-banner',
  templateUrl: './consent-banner.component.html',
  styleUrls: ['./consent-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ConsentBannerComponent {
  readonly currentLang$ = this.languageService.currentLanguage$;

  readonly consentForm: FormGroup<ControlsOf<ConsentFormValues>> = this.formBuilder.group(
    {
      bradmax: this.formBuilder.nonNullable.control(false),
      googleAnalytics: this.formBuilder.nonNullable.control(false),
      googleMarketingPersonalization: this.formBuilder.nonNullable.control(false),
      googleMarketingAdStorage: this.formBuilder.nonNullable.control(false),
      googleMarketingAdUserData: this.formBuilder.nonNullable.control(false),
    },
  );

  showNecessary = false;

  showMarketing = false;

  showAnalytics = false;

  showCookieConsentBanner$ = new BehaviorSubject(true);

  bannerLayer: BannerLayerType = 'main';

  constructor(
    private readonly formBuilder: FormBuilder,
    @Inject(DOCUMENT) readonly document: Document,
    private readonly consentService: ConsentService,
    @Inject(ASSET_MAP) readonly assetMap: AssetMap,
    private readonly languageService: LanguageService,
    readonly cdr: ChangeDetectorRef,
  ) {
    this.checkConsent();
  }

  showDetailedLayer() {
    this.bannerLayer = 'detailed';
  }

  acceptAll() {
    Object.keys(this.consentForm.controls).forEach(control =>
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      this.consentForm.controls[control].setValue(true),
    );
    this.consentService.setConsentCookie(this.consentForm.value as any);
    this.showCookieConsentBanner$.next(false);
  }

  acceptSelected() {
    this.consentService.setConsentCookie(this.consentForm.value as any);
    this.showCookieConsentBanner$.next(false);
  }

  denyAll() {
    Object.keys(this.consentForm.controls).forEach(control =>
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      this.consentForm.controls[control].setValue(false),
    );

    this.consentService.setConsentCookie(this.consentForm.value as any);
    this.showCookieConsentBanner$.next(false);
  }

  checkConsent() {
    const consentCookie = this.consentService.getConsentCookie();

    if (consentCookie) {
      this.showCookieConsentBanner$.next(false);
      this.consentForm.patchValue(consentCookie);
    }
  }

  showBannerWithDetailedLayer() {
    this.showCookieConsentBanner$.next(true);
    this.bannerLayer = 'detailed';
  }
}
